import { render, staticRenderFns } from "./Adaptives.vue?vue&type=template&id=54b8cebe&"
import script from "./Adaptives.vue?vue&type=script&lang=js&"
export * from "./Adaptives.vue?vue&type=script&lang=js&"
import style0 from "./Adaptives.vue?vue&type=style&index=0&id=54b8cebe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports